import { useMediaQuery } from '@mui/material';
import breakpoints from 'theme/breakpoints';

const defaultBreakpoint = 'sm';

export const useIsMobileDevice = (
  size: keyof typeof breakpoints.values = defaultBreakpoint,
) => {
  const chosenBreakpoint = breakpoints.values[size]
    ? breakpoints.values[size]
    : breakpoints.values[defaultBreakpoint];
  return useMediaQuery(`(max-width: ${chosenBreakpoint}px)`);
};
